import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useApp } from "../contexts/AppContext";
import { SERVICES, CATEGORIES } from "../lib/services";
import ServiceIcon from "../components/ServiceIcon";
import { Search, ArrowRight } from "lucide-react";

const Services = () => {
    const { t, lang } = useApp();
    const [q, setQ] = useState("");
    const [cat, setCat] = useState("All");

    const filtered = useMemo(() => {
        return SERVICES.filter((s) => {
            const matchQ = !q || s.name[lang].toLowerCase().includes(q.toLowerCase()) || s.name.en.toLowerCase().includes(q.toLowerCase());
            const matchC = cat === "All" || s.category === cat;
            return matchQ && matchC;
        });
    }, [q, cat, lang]);

    return (
        <div data-testid="page-services" className="container-x section-pad">
            <div className="max-w-3xl">
                <div className="chip bg-[hsl(var(--royal))]/10 text-[hsl(var(--royal))] mb-4">{t.nav.services}</div>
                <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">{t.services.title}</h1>
                <p className="mt-3 text-muted-foreground">{t.services.desc}</p>
            </div>

            <div className="mt-10 flex flex-col lg:flex-row gap-4 lg:items-center">
                <div className="relative flex-1">
                    <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground" />
                    <input data-testid="services-search" value={q} onChange={(e) => setQ(e.target.value)}
                        placeholder={t.services.searchPh}
                        className="w-full h-12 pl-11 pr-4 rounded-full border-2 border-border bg-background focus:border-[hsl(var(--royal))] focus:outline-none transition-colors" />
                </div>
                <div className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1">
                    {CATEGORIES.map((c) => (
                        <button key={c} data-testid={`cat-${c}`} onClick={() => setCat(c)}
                            className={`px-4 h-10 rounded-full text-xs font-semibold whitespace-nowrap transition-colors border ${
                                cat === c ? "bg-[hsl(var(--royal))] text-white border-[hsl(var(--royal))]" : "bg-background border-border hover:bg-muted"
                            }`}>{c}</button>
                    ))}
                </div>
            </div>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {filtered.map((s, i) => (
                    <Link key={s.id} to={`/booking?service=${s.id}`} data-testid={`service-card-${s.id}`}
                        className={`service-tile group fade-up delay-${(i % 5) * 100}`}>
                        <div className="flex items-start justify-between mb-4">
                            <div className="w-12 h-12 rounded-2xl flex items-center justify-center bg-[hsl(var(--royal))]/10 text-[hsl(var(--royal))] group-hover:bg-[hsl(var(--gold))]/20 group-hover:text-[hsl(var(--royal-deep))] transition-colors">
                                <ServiceIcon name={s.icon} size={22} />
                            </div>
                            <span className="chip bg-muted text-muted-foreground">{s.category}</span>
                        </div>
                        <h3 className="text-lg font-semibold tracking-tight">{s.name[lang]}</h3>
                        <p className="mt-1 text-sm text-muted-foreground">{s.desc[lang]}</p>
                        <div className="mt-4 text-sm font-semibold text-[hsl(var(--royal))] inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                            {t.services.book} <ArrowRight size={14} />
                        </div>
                    </Link>
                ))}
                {filtered.length === 0 && (
                    <div className="col-span-full text-center text-muted-foreground py-16">No services found.</div>
                )}
            </div>
        </div>
    );
};

export default Services;
